import React from "react";
import Card from "react-bootstrap/Card";

import './Resume.css'
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Badge from "react-bootstrap/Badge";

function Resume_Top() {
  return (
    <>
      <div>
        <h1 className="text-left font-weight-bold top-font">
          Hello,
        </h1>
        <p className="text-left top-font">
          <span className="h3">
            a bit about me :
          </span>
        </p>

        <Row>
          <Col>
            <div className="d-flex">
              <Badge pill bg="white" border="1px solid #66CDAA" className={"resume-badges"}>
                #consistency
              </Badge>
            </div>
          </Col>
          <Col>
            <div className="d-flex">
              <Badge pill bg="white" border="1px solid #66CDAA" className={"resume-badges"}>
                #recordkeeping
              </Badge>
            </div>
          </Col>
          <Col>
            <div className="d-flex">
              <Badge pill bg="white" border="1px solid #66CDAA" className={"resume-badges"}>
                #organization
              </Badge>
            </div>
          </Col>
        </Row>

        <p className="text-left" style={{ marginTop: "5%" }}>
          <span className="h6" style={{ fontFamily: "Noto Sans KR", color: "white" }}>
            I'm someone who believes that even with a small amount, if done <b>consistently</b>, it can be achieved. <br></br>
            I love setting goals and <b>accomplishing</b> them. <br></br>
            Doing <b>document work</b> such as Excel, Word, PPT is something I really enjoy. <br></br>
            I'm far from being a perfectionist. I'm a <b>completionist</b>. <br></br>

            <hr></hr>

            <i>
              <b>Note</b>
            </i>{" "}
            <br></br>

            <b>1.</b> Surprisingly, I've lived as an <b>ENFP</b> for the past <b>21 years</b>. <br></br>
            <b>2.</b> I lost <b>24kg</b> in just <b>1 year</b> and have been maintaining it since then. <br></br>
            <b>3.</b> My favorite food is <b>ramen</b>. It's delicious and convenient, isn't it? <br></br>
          </span>
        </p>

      </div>
    </>
  );
}

export default Resume_Top;
